module.exports = __webpack_public_path__ + "img/61.6e209440.jpg";